import { Action } from '@ngrx/store';
import { Section } from './section';
import { IAdditionalContentFixtureDetailsDto, RequestStatus, IParticipantDto, ParticipantDto, NoteDto, AdditionalContentType, CameraOperator } from '../../../../../services/bpp.webapi/client';
import * as moment from 'moment-timezone';
import { StatusHelper } from '../../../../../helpers/statuses-helper';

export class ViewState {
  public isNew = false;
  public lastSavedOn = '';
  public lastSavedBy = '';
  public date: moment.Moment;
  public arrival: moment.Moment;
  public startTime: moment.Moment;
  public location = '';
  public locationData = '';
  public eventId = '';
  public showDeleteButton = false;
  public saveDisabled=false;
  public submitDisabled=false;
  public editDisabled=false;
  public deleteDisabled=false;
  
  public showStatus = true;
  public clubName = '';
  public sessionMonth = '';
  public imagePath = '';
  public note = '';
  public clubNote: NoteDto;
  public leagueNote: NoteDto;
  public loading:boolean;
  public additionalContentType:AdditionalContentType;

  public sections = new Array<Section>();
  public reporters = Section.reporters;
  public cameras = Section.cameras;
  public producers = Section.producers;
  public others = Section.others;
  public participants = new Array<IParticipantDto>();
  public editState = false;

  setAdditionalContent(additionalContent: IAdditionalContentFixtureDetailsDto) {
    this.lastSavedOn = moment.utc(additionalContent.updatedOn).local().format('DD/MM/YYYY | HH:mm');
    this.lastSavedBy = additionalContent.updatedByName;
    this.date = moment.utc(additionalContent.start);
    this.arrival = moment.utc(additionalContent.arrival);
    this.startTime = moment.utc(additionalContent.start);
    this.location = additionalContent.location.title;
    this.eventId = additionalContent.eventId;
    this.clubName = additionalContent.club;
    this.clubNote = additionalContent.clubNote;
    this.leagueNote = additionalContent.leagueNote;
    this.imagePath = '../../../../assets/teams/48/t' + additionalContent.clubId + '.png';
    this.additionalContentType = additionalContent.type;

    this.sessionMonth = moment.utc(additionalContent.arrival).format('MMMM');

    this.sections.push(this.reporters);
    this.cameras.cameraOperator = additionalContent.requests && additionalContent.requests[0] && additionalContent.requests[0].cameraOperator || CameraOperator.AudioOnly;
    this.sections.push(this.cameras);
    this.sections.push(this.producers);
    this.sections.push(this.others);
  }

  public getAction(status: RequestStatus): Action {
    return undefined;
  }

  getParticipants(): Array<ParticipantDto> {
    const result = new Array<ParticipantDto>();

    for (const section of this.sections) {
      for (const item of section.participants) {
        result.push(new ParticipantDto(item));
      }
    }

    return result;
  }

  isReadOnly() {
    return true;
  }

  isCanChange() {
    return !StatusHelper.isDatePassed(this.startTime);
  }

  toggleState() {
    if (this.isCanChange() && this.editState === false) {
      this.editState = true;
    } else {
      this.editState = false;
    }
  }
}
